import { render, staticRenderFns } from "./PointListComponent.vue?vue&type=template&id=5cd1561c&scoped=true&"
import script from "./PointListComponent.vue?vue&type=script&lang=js&"
export * from "./PointListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1561c",
  null
  
)

export default component.exports